import { combineReducers } from 'redux';

import { reducer as form } from './State/form';
import { reducer as submitting } from './State/submitting';
import { reducer as supplier } from './State/supplier';

export default combineReducers({
  form,
  submitting,
  supplier,
})
